// shared-routing.ts — pure routing helpers for chat sharing. Dependency-free on
// purpose (no api/auth/runes imports) so it unit-tests in isolation and both the
// sidebar link and the /s/ → /shared redirect use the SAME path construction
// (they drifted apart would silently break grantee access).

/** The read-only viewer path for a chat someone shared with me. `ownerSub` is an
 *  Auth0 sub that can contain "|", so it MUST be percent-encoded in the path. */
export function sharedViewerHref(ownerSub: string, sessionId: string): string {
	return `/shared/${encodeURIComponent(ownerSub)}/${encodeURIComponent(sessionId)}`;
}

/** A `/s/<id>` URL is the OWN-chats route; it only resolves sessions in the
 *  caller's own container. When the agent reports `<id>` as "unknown session"
 *  (not mine), this checks whether it's instead a chat shared WITH me and, if so,
 *  returns the `/shared/<owner>/<id>` viewer href to redirect to. `null` ⇒ the id
 *  is neither mine nor shared with me → genuinely not available. */
export function resolveSharedViewerHref(
	sessionId: string,
	shared: readonly { sessionId: string; ownerSub: string }[],
): string | null {
	const match = shared.find((s) => s.sessionId === sessionId);
	return match ? sharedViewerHref(match.ownerSub, sessionId) : null;
}
